@if (titleCard.image) {
  <div class="card-container">
    <div class="image">
      <div class="image-text">
        <div class="image-text-title">{{ titleCard.title }}</div>
        <div class="image-text-description">
          <div class="image-text-description-bold">
            {{ titleCard.descriptionBold }}
          </div>
          {{ titleCard.description }}
        </div>
      </div>
    </div>
  </div>
} @else {
  <app-hero-card-placeholder
    class="hero-card-placeholder"
    [colorHead]="titleCard.color0"
    [colorShapes]="titleCard.color70"
    [backgroundColor]="titleCard.color80">
    <div class="image-text">
      <div class="image-text-title" [style.color]="titleCard.color0">
        {{ titleCard.title }}
      </div>
      <div class="image-text-description">
        <div class="image-text-description-bold">
          {{ titleCard.descriptionBold }}
        </div>
        {{ titleCard.description }}
      </div>
    </div>
  </app-hero-card-placeholder>
}
